import { render, staticRenderFns } from "./EditCompensationApproval.vue?vue&type=template&id=02190fa9&scoped=true"
import script from "./EditCompensationApproval.vue?vue&type=script&lang=js"
export * from "./EditCompensationApproval.vue?vue&type=script&lang=js"
import style0 from "./EditCompensationApproval.vue?vue&type=style&index=0&id=02190fa9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02190fa9",
  null
  
)

export default component.exports